import { useState } from "react";
import {
  PlansGetReportPlansCsvListPostRequest,
  ResponseGetReportPlansCsvListResponse,
  RequestGetReportPlansCsvListRequest,
  PlansApi,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiGetReportPlansCsvList = () => {
  const [reportPlanCsvList, setReportPlanCsvList] =
    useState<ResponseGetReportPlansCsvListResponse | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchReportPlanCsvList = async (
    requestParams: RequestGetReportPlansCsvListRequest
  ) => {
    setIsLoading(true);
    setError(null);

    try {
      const config = createConfiguration();
      const request: PlansGetReportPlansCsvListPostRequest = {
        req: requestParams,
      };

      const api = new PlansApi(config);
      const response = await api.plansGetReportPlansCsvListPost(request);
      setReportPlanCsvList(response);
      return response;
    } catch (err) {
      setError("プランCSVの取得に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { reportPlanCsvList, fetchReportPlanCsvList, error, isLoading };
};
